import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SafetyCheckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"safety_check"}/>
}
